var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.086 8H11.414C11.1414 8.00026 10.8708 8.04553 10.613 8.134C10.548 8.15575 10.477 8.14999 10.4164 8.11809C10.3558 8.08617 10.3109 8.03087 10.292 7.965L10.02 7.015C10.0177 7.00594 10.0094 6.99971 10 7C8.89542 7 8 6.10457 8 5V2C8 0.895432 8.89542 0 10 0H16.5C17.6046 0 18.5 0.895432 18.5 2V5C18.5 6.10457 17.6046 7 16.5 7C16.4903 6.99921 16.4814 7.00555 16.479 7.015L16.207 7.965C16.1882 8.03087 16.1432 8.08617 16.0826 8.11809C16.022 8.14999 15.951 8.15575 15.886 8.134C15.6285 8.04564 15.3582 8.00037 15.086 8ZM10.5 2C10.2238 2 10 2.22385 10 2.5V4.5C10 4.77614 10.2238 5 10.5 5H16C16.2762 5 16.5 4.77614 16.5 4.5V2.5C16.5 2.22385 16.2762 2 16 2H10.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 20.5C15.0449 20.5 16.5 19.0449 16.5 17.25C16.5 15.4551 15.0449 14 13.25 14C11.4551 14 10 15.4551 10 17.25C10 19.0449 11.4551 20.5 13.25 20.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 11H17.914C17.7816 11 17.6547 10.9475 17.561 10.854L16.146 9.439C15.8641 9.159 15.4833 9.00128 15.086 9H11.414C11.0167 9.00128 10.6359 9.159 10.354 9.439L8.939 10.854C8.84531 10.9475 8.71835 11 8.586 11H3.5C2.11929 11 1 12.1193 1 13.5V21.5C1 22.163 1.2634 22.7989 1.73224 23.2678C2.20108 23.7366 2.83694 24 3.5 24H20.5C21.1631 24 21.7989 23.7366 22.2678 23.2678C22.7366 22.7989 23 22.163 23 21.5V13.5C23 12.1193 21.8807 11 20.5 11ZM6 14.75C6 15.4404 5.44037 16 4.75 16C4.05963 16 3.5 15.4404 3.5 14.75C3.5 14.0596 4.05963 13.5 4.75 13.5C5.44037 13.5 6 14.0596 6 14.75ZM13.25 12C10.3505 12 8 14.3505 8 17.25C8.0033 20.1481 10.3519 22.4967 13.25 22.5C16.1495 22.5 18.5 20.1495 18.5 17.25C18.5 14.3505 16.1495 12 13.25 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.5C7 8.67157 6.32843 8 5.5 8H4.5C3.67157 8 3 8.67157 3 9.5C3 9.77614 3.22386 10 3.5 10H6.5C6.77614 10 7 9.77614 7 9.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFlash);
export default __webpack_public_path__ + "static/media/cameraFlash.cf0a2ec6.svg";
export { ForwardRef as ReactComponent };